// @flow
import { combineReducers } from 'redux';
import { MOUNT_POINT as MSG_DIALOG_MOUNT_POINT } from './msgDialog/constants';
import { MOUNT_POINT as FORM_MOUNT_POINT } from './form/constants';
import msgDialog from './msgDialog/reducer';
import form from './form/reducer';
import type { State as MsgDialogState } from './msgDialog/reducer';
import type { State as FormState } from './form/reducer';

export type State = {
    msgDialog: MsgDialogState,
    form: FormState,
};

export default combineReducers({
    [MSG_DIALOG_MOUNT_POINT]: msgDialog,
    [FORM_MOUNT_POINT]: form,
});
